import React, { forwardRef, Ref, useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import * as pdfjsWorker from "../../../../externalDependecies/workers/pdf.worker.min.mjs";
import "./styles.css";
import { useSelector } from "react-redux";
import {
  PREVIEW_TYPE_COMPACT,
  PREVIEW_TYPE_STANDARD,
} from "../../config/constants";
import { COMPACT_MODE_HEIGHT } from "../contants";
import { getPdfDimensions } from "../../utils/helpers";
import { useTranslate } from "@tolgee/react";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  pdfjsWorker.WorkerMessageHandler,
  import.meta.url
).toString();
interface PdfComponentProps {
  url: string;
  previewMode?: string;
}

const PdfComponent: React.FC<PdfComponentProps> = ({ url, previewMode: propPreviewMode }) => {
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);

  const { t } = useTranslate();

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () => setPageNumber(pageNumber - 1);
  const goToNextPage = () => setPageNumber(pageNumber + 1);
  const {
    ui: { previewMode: reduxPreviewMode },
  } = useSelector((state: any) => state.lomavisCreator);

  // Use prop value if provided, otherwise use Redux state
  const previewMode = propPreviewMode !== undefined ? propPreviewMode : reduxPreviewMode;
  const pdfContainerRef = useRef<HTMLDivElement | null>(null);
  const divRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const checkDimension = () => {
      const element = document.querySelector(".pdf_container");
      if (element) {
        const divWidth = (element as HTMLElement).clientWidth;
        const divHeight = (element as HTMLElement).clientHeight;

        setDimensions({
          width: divWidth,
          height: divHeight,
        });
      }
    };

    // Check if divRef is attached to an element
    if (divRef.current && previewMode === PREVIEW_TYPE_STANDARD) {
      setTimeout(() => {
        checkDimension();
      }, 1000);
    } else {
      setTimeout(() => {
        if (pdfContainerRef.current) {
          const { width, height } =
            pdfContainerRef.current.getBoundingClientRect();

          setDimensions({ width: width, height: height });
        }
      }, 500);
    }
  }, []);

  return (
    <div
      style={{
        maxHeight:
          previewMode === PREVIEW_TYPE_COMPACT ? COMPACT_MODE_HEIGHT : "100%",
        maxWidth:
          previewMode === PREVIEW_TYPE_COMPACT
            ? `${(dimensions.width / dimensions.height) * 100 - 2}%`
            : "100%",
      }}
      className="mx-auto"
    >
      <div
        style={{
          width: previewMode === PREVIEW_TYPE_COMPACT ? "auto" : "100%",
          overflow: "none",
        }}
        className="w-auto pdf_container"
        ref={divRef}
      >
        <div
          className="pdf-wrapper d-flex justify-content-center align-items-center position-relative"
          style={{
            width: "auto",
            height: "auto",
            objectFit: "contain", // Maintains the aspect ratio
          }}
          id="pdf-container"
          ref={pdfContainerRef}
        >
          <Document
            className="w-100 "
            renderMode="canvas"
            file={url}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Page
              pageNumber={pageNumber}
              renderMode="canvas"
              renderTextLayer={false}
            />
          </Document>
        </div>

        <div>
          {pageNumber > 1 && (
            <button
              className="btn btn-dark rounded-circle position-absolute prev-button d-flex justify-content-center align-items-center"
              onClick={goToPrevPage}
              style={{ width: "35px", left: "10px", top: "45%" }}
            >
              <i
                style={{ fontSize: "20px", paddingLeft: "6px" }}
                className="fa-regular fa-chevron-left"
              ></i>
            </button>
          )}

          {numPages && pageNumber < numPages && (
            <button
              className="btn btn-dark rounded-circle position-absolute next-button d-flex justify-content-center align-items-center text-white"
              onClick={goToNextPage}
              style={{ width: "35px", right: "10px", top: "45%" }}
            >
              <i
                style={{ fontSize: "20px", paddingLeft: "6px" }}
                className="fa-regular fa-chevron-right"
              ></i>
            </button>
          )}
        </div>
        <p className="text-center mt-3 w-100">
          {t("lomavisCreator.pdf.Page")} {pageNumber}{" "}
          {t("lomavisCreator.pdf.of")} {numPages}
        </p>
      </div>
    </div>
  );
};

export default PdfComponent;
